export class Permissions {
  /**
   * Dashboard
   */
  public static readonly DASHBOARD_VIEW = "admin:dashboard:view";
  /**
   * User Management
   */
  public static readonly USER_MANAGEMENT_VIEW = "admin:user:management:view";
  public static readonly USER_MANAGEMENT_ADD = "admin:user:management:add";
  public static readonly USER_MANAGEMENT_EDIT = "admin:user:management:edit";

  /**
   * Organizations
   */
  public static readonly ORGANIZATIONS_VIEW = "admin:organizations:view";
  public static readonly ORGANIZATIONS_ADD = "admin:organizations:add";
  public static readonly ORGANIZATIONS_EDIT = "admin:organizations:edit";
  public static readonly ORGANIZATIONS_DELETE = "admin:organizations:delete";

  /**
   * Brands
   */
  public static readonly BRANDS_VIEW = "admin:brands:view";
  public static readonly BRANDS_ADD = "admin:brands:add";
  public static readonly BRANDS_EDIT = "admin:brands:edit";
  public static readonly BRANDS_DELETE = "admin:brands:delete";

  /**
   * Purchasers
   */
  public static readonly PURCHASERS_VIEW = "admin:purchasers:view";
  public static readonly PURCHASERS_ADD = "admin:purchasers:add";
  public static readonly PURCHASERS_EDIT = "admin:purchasers:edit";

  /**
   * Master Data
   */
  public static readonly MASTER_DATA_VIEW = "admin:master:data:view";
  public static readonly MASTER_DATA_ADD = "admin:master:data:add";
  public static readonly MASTER_DATA_EDIT = "admin:master:data:edit";
  public static readonly MASTER_DATA_DELETE = "admin:master:data:delete";

  /**
   * Config (Data Provider / Portal Credentials)
   */
  public static readonly CONFIG_VIEW = "admin:config:view";
  public static readonly CONFIG_ADD = "admin:config:add";
  public static readonly CONFIG_EDIT = "admin:config:edit";
  public static readonly CONFIG_DELETE = "admin:config:delete";
}
